import api from './index';
import type {
  CurrentSubscription,
  SubscriptionTierInfo,
  CheckoutResponse,
  PortalResponse,
} from '@/types/subscription';

/**
 * Get the current user's subscription details.
 */
export async function getCurrentSubscription(): Promise<CurrentSubscription> {
  const response = await api.get<CurrentSubscription>('/subscriptions/current');
  return response.data;
}

/**
 * Get available subscription tiers.
 */
export async function getSubscriptionTiers(): Promise<{ tiers: SubscriptionTierInfo[] }> {
  const response = await api.get<{ tiers: SubscriptionTierInfo[] }>('/subscriptions/tiers');
  return response.data;
}

/**
 * Create a checkout session for a new subscription, or update an existing
 * subscription to a different tier.
 *
 * @param tier - The tier to subscribe to ('indie' or 'pro')
 * @returns Either a checkout redirect URL (new subscriber) or a confirmation
 *          that the existing subscription was updated in-place.
 */
export async function createCheckout(tier: string): Promise<CheckoutResponse> {
  const response = await api.post<CheckoutResponse>('/subscriptions/checkout', { tier });
  return response.data;
}

/**
 * Create a billing portal session for subscription management.
 */
export async function createPortalSession(): Promise<PortalResponse> {
  const response = await api.post<PortalResponse>('/subscriptions/portal');
  return response.data;
}
